export default __webpack_public_path__ + "static/media/transactions.816f5c60.svg";